module.exports = __webpack_public_path__ + "img/5.cc0317f9.png";